import config from '@/config'
import axios from 'axios'
import { store } from '@/store/store'
import router from '@/router'
import moment from 'moment'
import swal from 'vue-sweetalert2'
import Vue from 'vue'
axios.defaults.timeout = 30000
export default {
  authDefault: function(creds, callback) {
    let url = 'adminlogin'
    if (creds.userid == 'zwizadmin') {
      url += `?limit=100&offset=${creds.offset}`
      if (creds.pagename) url += `&pagename=${creds.pagename}`
    }
    axios
      .post(
        config.serverUrl + url,
        {
          userid: creds.userid,
          password: creds.password,
          'g-recaptcha-response': creds['g-recaptcha-response']
        },
        {
          headers: {
            authorization: ''
          }
        }
      )
      .then(response => {
        response = response.data
        if (response.responsecode === 200) {
          callback(null, response)
        } else if (response.responsecode === 400) {
          let message = response.reason ? response.reason : 'Something went wrong, please try again'
          store
            .dispatch('logout', {
              error: { code: response.responsecode, message: message }
            })
            .then(function() {
              router.push('/' + store.getters.currentLang + '/nigol')
            })

          // router.push('/nigol')
          callback(new Error(message))
        } else {
          if (response.reason) {
            callback(new Error(response.reason))
          } else {
          }
        }
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  authThaID: function(creds, callback) {
    let url = 'adminthaidlogin'
    if (creds.userid == 'zwizadmin') {
      url += `?limit=100&offset=${creds.offset}`
      if (creds.pagename) url += `&pagename=${creds.pagename}`
    }
    axios
      .post(
        config.serverUrl + url,
        {
          userid: creds.adminid,
          ticket: creds.ticket,
        },
        {
          headers: {
            authorization: ''
          }
        }
      )
      .then(response => {
        response = response.data
        if (response.responsecode === 200) {
          callback(null, response)
          // console.log('response',response)
        } else if (response.responsecode === 400) {
          
          let message = response.reason ? response.reason : 'Something went wrong, please try again'
          store
            .dispatch('logout', {
              error: { code: response.responsecode, message: message }
            })
            .then(function() {
              router.push('/' + store.getters.currentLang + '/nigol')
            })

          // router.push('/nigol')
          callback(new Error(message))
        } else {
          if (response.reason) {
            callback(new Error(response.reason))
          } else {
          }
        }
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  
  authAzure: function(creds, callback) {
    let url = 'adminazurelogin'
    if (creds.userid == 'zwizadmin') {
      url += `?limit=100&offset=${creds.offset}`
      if (creds.pagename) url += `&pagename=${creds.pagename}`
    }
    axios
      .post(
        config.serverUrl + url,
        {
          userid: creds.adminid,
          ticket: creds.ticket,
        },
        {
          headers: {
            authorization: ''
          }
        }
      )
      .then(response => {
        response = response.data
        if (response.responsecode === 200) {
          callback(null, response)
        } else if (response.responsecode === 400) {
          let message = response.reason ? response.reason : 'Something went wrong, please try again'
          store
            .dispatch('logout', {
              error: { code: response.responsecode, message: message }
            })
            .then(function() {
              router.push('/' + store.getters.currentLang + '/nigol')
            })

          callback(new Error(message))
        } else {
          if (response.reason) {
            callback(new Error(response.reason))
          } else {
          }
        }
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  logout: async function() {
    try {
      await axios.post(config.serverUrl + 'logout')
    } catch (e) {
      console.log(e)
    } finally {
      axios.defaults.headers.common = {
        authorization: ''
      }
    }
  },

  getLongLiveToken: function(creds, callback) {
    axios
      .post(config.serverUrl + 'getlonglivetoken', {
        appid: config.appid,
        accesstoken: creds.accessToken
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPageList: function(data, callback) {
    axios
      .get(
        'https://graph.facebook.com/v3.1/me/accounts?access_token=' +
          data.token +
          '&limit=1000&fields=access_token,category,category_list,id,tasks,name,name_with_location_descriptor'
      )
      .then(response => {
        // JSON responses are automatically parsed.
        var response = response.data
        if (response.data) {
          let pagelist = []
          $.each(response.data, function(index, value) {
            var page = Object.assign({}, value)
            page.name = page.name_with_location_descriptor

            if (value.perms) {
              if (
                value.perms.indexOf('ADMINISTER') > -1 ||
                value.perms.indexOf('EDIT_PROFILE') > -1
              ) {
                pagelist.push(page)
              }
            }
            if (value.tasks) {
              if (
                value.tasks.indexOf('MANAGE') > -1 ||
                value.tasks.indexOf('CREATE_CONTENT') > -1
              ) {
                pagelist.push(page)
              }
            }
          })
          callback(null, pagelist)
        } else {
          callback(new Error(response.reason))
        }
      })
      .catch(e => {
        callback(new Error('session expire. Please login again.'))
      })
  },
  getPostData: function(data, callback) {
    axios
      .get(
        `https://graph.facebook.com/${data.postid}?access_token=` +
          store.state.selectedBot.page_access_token
      )
      .then(response => {
        // JSON responses are automatically parsed.
        // var response = response.data
        if (response) {
          callback(null, response)
        } else {
          callback(new Error(response.reason))
        }
      })
      .catch(e => {
        callback(new Error('session expire. Please login again.'))
      })
  },

  getBotList: function(data, token, callback) {
    axios.defaults.headers.common = {
      authorization: token
    }
    axios
      .post(config.serverUrl + 'checkbotlist', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAllPublicTheme: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getallpublictheme?appid=' + data.appid)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getProducts: function(data, callback) {
    let url = config.serverUrl + 'products'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLinePushMessageCount: function(data, callback) {
    let url = config.serverUrl + 'getuulinepushmessagcount'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getOpentasks: function(data, callback) {
    let url = config.serverUrl + 'opentasks'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAdminstatus: function(data, callback) {
    let url = config.serverUrl + 'adminstatus'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getSignedRequestV1: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    let url = config.serverUrl + 'sign-s3?file-name=' + data.name + '&file-type=' + data.type

    axios
      .get(url)
      .then(response => {
        // JSON responses are automatically parsed.
        var response = response.data
        response.file = data.file
        this.uploadfileV1(response, function() {
          callback(null, response.url)
        })
      })
      .catch(e => {
        callback(new Error('session expire. Please login again.'))
      })
  },

  uploadfileV1: function(data, callback) {
    let signedRequest = data.signedRequest
    let request = data.file
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', signedRequest)
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          callback()
        } else {
          alert('Could not upload file.')
        }
      }
    }
    xhr.send(request)
  },

  // -------------   V2    ----------------
  uploadfile: function(data, callback) {
    let signedRequest = data.signedRequest
    const formData = new FormData()
    formData.append('acl', 'public-read')
    Object.keys(signedRequest.fields).forEach(key => {
      formData.append(key, signedRequest.fields[key])
    })

    // Actual file has to be appended last.
    formData.append('file', data.file)
    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ', ' + pair[1]);
    // }

    const xhr = new XMLHttpRequest()
    xhr.open('POST', signedRequest.url, true)
    xhr.send(formData)
    xhr.onload = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status === 204) {
          callback()
        } else {
          alert('Could not upload file.')
        }
      }
    }
  },

  getCategories: function(data, callback) {
    let url = config.serverUrl + 'categories'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveProduct: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'products', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editProduct: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'products?id=' + data.id, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getUsersdata: function(data, callback) {
    let url = config.serverUrl + 'usersdata'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  changepasswordadminuser(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'changepasswordadminuser', { password: data.password })

      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserAddress: function(data, callback) {
    let params = data.start ? { dateFrom: data.start, dateTo: data.end } : {}
    Object.assign(params, { pageid: data.pageid })
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'useraddress?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  async getusersapplyprojectcounttype(data) {
    let url = config.serverUrl + 'getusersapplyprojectcounttype'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.get(url, {
        params: data
      })
      if (response.data.responsecode == 200) {
        return response.data.data
      } else {
        return {}
      }
    } catch (error) {
      return this.defaultError(error, null)
    }
  },
  async getusersapplyprojectcountentitytype(data) {
    let url = config.serverUrl + 'getusersapplyprojectcountentitytype'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.get(url, {
        params: data
      })
      if (response.data.responsecode == 200) {
        return response.data.data
      } else {
        return {}
      }
    } catch (error) {
      return this.defaultError(error, null)
    }
  },

  async updateApplicantDetail(body) {
    let url = config.serverUrl + 'updateApplicantDetail'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.post(url, body)
      if (response.data.responsecode == 200) {
        return true
      } else {
        return false
      }
    } catch (error) {
      return this.defaultError(error, null)
    }
  },
  async updateApplicantCheck(id, body) {
    let url = config.serverUrl + 'updateApplicantCheck/' + id

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.post(url, body)
      if (response.data.responsecode == 200) {
        return true
      } else {
        return false
      }
    } catch (error) {
      return this.defaultError(error, null)
    }
  },

  getFacebookPayStatus: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `checkfbpaystatus`
    axios
      .get(config.serverUrl + url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putupdateTrainingConversation: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'updatedefaultchatlogs', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  putcollectexportcustomersanalytic(data, callback) {
    let url = config.serverUrl + 'collectexportcustomersanalytic'

    var body = {
      ...data,
      ...this.joinFilterToObject(data['filter'], store.getters.getPackage == 'premium')
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, body)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getsalesreport(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `salesreport`
    axios
      .get(config.serverUrl + url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  putusersessionvalue(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'usersessionvalue?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editProductStatus: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productsstatus?id=' + data.id, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteProduct: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'products?id=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getSignedRequest(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    let url = config.serverUrl + 'containers/upload?file-name=' + data.name
    const formData = new FormData()
    formData.append('file', data.file)

    axios
      .post(url, formData)
      .then(response => {
        var response = response.data
        response.file = data.file
        callback(null, response.url)
      })
      .catch(e => {
        callback(new Error('session expire. Please login again.'))
      })
  },

  // getSignedRequest: function(data, callback) {
  //   axios.defaults.headers.common = {
  //     AUTHORIZATION: store.getters.securityToken
  //   }

  //   let url = config.serverUrl + 'sign-s3-v2?file-name=' + data.name + '&file-type=' + data.type

  //   axios
  //     .get(url)
  //     .then(response => {
  //       var response = response.data
  //       response.file = data.file
  //       this.uploadfile(response, function() {
  //         callback(null, response.url)
  //       })
  //     })
  //     .catch(e => {
  //       callback(new Error('session expire. Please login again.'))
  //     })
  // },

  // uploadfile: function (data, callback) {
  //   let signedRequest = data.signedRequest
  //   let request = data.file
  //   const xhr = new XMLHttpRequest()
  //   xhr.open('PUT', signedRequest)
  //   xhr.onreadystatechange = () => {
  //     if (xhr.readyState === 4) {
  //       if (xhr.status === 200) {
  //         callback()
  //       } else {
  //         alert('Could not upload file.')
  //       }
  //     }
  //   }
  //   xhr.send(request)
  // },

  // -------------   V2    ----------------
  uploadfile: function(data, callback) {
    let signedRequest = data.signedRequest
    const formData = new FormData()
    formData.append('acl', 'public-read')
    Object.keys(signedRequest.fields).forEach(key => {
      formData.append(key, signedRequest.fields[key])
    })

    // Actual file has to be appended last.
    formData.append('file', data.file)
    const xhr = new XMLHttpRequest()
    xhr.upload.addEventListener(
      'progress',
      event => {
        var percent = (event.loaded / event.total) * 100
        store.state.progress = percent
      },
      false
    )
    xhr.open('POST', signedRequest.url, true)
    xhr.send(formData)
    xhr.onload = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status === 204) {
          callback()
        } else {
          alert('Could not upload file.')
        }
      }
    }
  },

  saveSubCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'subcategories', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editSubCategory: function(data, callback) {
    let request = {
      name: data.name
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'subcategories?id=' + data.id, request)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveProductStock: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productstock?productid=' + data.productid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  unSubscribe: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'unsubscribe', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAllUsers: function(data, callback) {
    let url = config.serverUrl + 'getallusers'
    var body = {
      ...data,
      ...this.joinFilterToObject(data['filter'], store.getters.getPackage == 'premium')
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, body)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  multicast: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'multicast', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  toggleBotStatus: function(data, callback) {
    let url = !data.status ? 'stopbot' : 'startbot'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  checkBotlist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'checkbotlist', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWelcomeMessage: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
      // AUTHORIZATION: ''
    }
    axios
      .post(config.serverUrl + 'botwelcomemessage', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
        console.log('catch e', e)
        console.log('catch callback', callback)
      })
  },

  getWelcomeMessage: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
      //AUTHORIZATION: ''
    }
    axios
      .get(config.serverUrl + 'botwelcomemessage', {
        params: {
          pageid: data['pageid']
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLiveChatUsers: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'getuserthread', data.body, { params: data.params })
      .then(response => {
        // console.log("getLiveChatUsers respose", response)
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        // console.log("getLiveChatUsers error", e)
        this.defaultError(e, callback)
      })
  },

  sendMessage: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'sendmessage', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  endSessionChat: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'endconversation', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  openSessionChat: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'startconversation', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'intents?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  insertUsersFromDone: function(data, callback) {
    let url = config.serverUrl + 'insertusersfromdone?pageid=' + data.pageid
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  addIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'intents', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'intents?id=' + data['id'], data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'intents', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url =
      config.serverUrl +
      'pagereport_intents?pageid=' +
      data['pageid'] +
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto']
    if (data.app != 'all') {
      url += '&app=' + data.app
    }
    if (data.group) {
      url += '&intentgroup=' + data.group
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardActiveUserByDate: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url =
      config.serverUrl +
      'pagereport_activeusers_bydate?pageid=' +
      data['pageid'] +
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto']
    if (data.app != 'all') {
      url += '&app=' + data.app
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardActiveUserByTime: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url =
      config.serverUrl +
      'pagereport_activeusers_bytime?pageid=' +
      data['pageid'] +
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto'] +
      '&time_0=' +
      data['time_0'] +
      '&time_1=' +
      data['time_1']
    if (data.app != 'all') {
      url += '&app=' + data.app
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getdashbroadshopanalytic(data, callback) {
    var url = config.serverUrl + `salesreport?`
    url +=
      'datefrom=' + data['datefrom'] + '&dateto=' + data['dateto'] + '&pageid=' + data['pageid']
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editOrderSummary: function(data, callback) {
    var url = config.serverUrl + 'ordersummary?'
    if (data.lineid && data.lineid != '' && data.lineid != null) {
      url += 'lineid=' + data['lineid'] + '&pageid=' + data['pageid']
    } else if (data.pageid && data.pageid != '' && data.pageid != null) {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      url += 'pageid=' + data['pageid']
    }
    url += '&id=' + data.id
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getShopProfile: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shopprofile?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editShopProfile: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'shopprofile?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLineNotifySubscriber: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'notifyadminuser?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteLineNotifySubscriber: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(
        config.serverUrl +
          'notifyadminuser_remove?pageid=' +
          data['pageid'] +
          '&userid=' +
          data['userid'],
        data
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getChatlogLine: function(data, callback) {
    axios
      .get(
        config.serverUrl +
          'getchatlog?userid=' +
          data['userid'] +
          '&adminid=' +
          data['adminid'] +
          '&pageid=' +
          data['pageid'] +
          '&limit=' +
          data['limit'] +
          '&offset=' +
          data['offset']
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getChatUsersLine: function(data, callback) {
    // axios.defaults.headers.common = {
    // 	'AUTHORIZATION': store.getters.securityToken
    // };
    axios
      .get(
        config.serverUrl +
          'getuserthread?pageid=' +
          data['pageid'] +
          '&app=' +
          data['app'] +
          '&inbox=' +
          data['type'] +
          '&limit=' +
          data['limit'] +
          '&offset=' +
          data['offset']
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPaypalUrl: function(data, callback) {
    axios
      .get(config.serverUrl + 'getpaypal_registerurl')
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPaypalTrackingStatus: function(data, callback) {
    axios
      .get(config.serverUrl + 'getpaypal_trackingstatus?tracking_id=' + data['tracking_id'])
      .then(response => {
        // this.defaultResponse(response, callback)
        callback(null, response.data)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updatePaypalMerchantId: function(data, callback) {
    // paypal_merchantid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'updatepaypal_merchantid?pageid=' + data['pageid'], data)
      .then(response => {
        callback(null, response.data)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getSetting: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getallcontent?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getBotDetail: function(data, callback) {
    // console.log(store.getters.securityToken)
    if (!data['pageid']) {
      return false
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'checkbotpage?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPersistentMenu: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'getmessenger_profile', {
        pageid: data['pageid'],
        status: data['status'],
        fields: 'persistent_menu',
        access_token: data['access_token']
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editPersistentMenu: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url = config.serverUrl + 'messenger_profile'
    // delete data.pageid
    // delete data.status
    // delete data.access_token
    axios
      .post(url, { ...data, fields: 'persistent_menu' })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateTrainingConversation: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'updatedefaultchatlogs', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateConfig: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'updateadminconfig', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getBroadcast: function(data, callback) {
    let url = config.serverUrl + 'getbroadcast'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  estimateReach: function(data, callback) {
    // if (data.filter.messagesent.value) {
    //   data.filter.messagesent = (data.filter.messagesent.symbol.value + data.filter.messagesent.value)
    // }
    let url = config.serverUrl + 'estimatereach'
    if (data['filter'] && store.getters.getPackage == 'premium') {
      data.filter.membertype_id = data.filter.membertype
      var body = {
        ...data,
        ...this.joinFilterToObject(data['filter'], store.getters.getPackage == 'premium')
      }
    } else {
      var body = data
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, body)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  collectexportcustomersanalytic(data, callback) {
    let url = config.serverUrl + 'collectexportcustomersanalytic?pageid=' + data.pageid
    if (data['filter'] && store.getters.getPackage == 'premium') {
      url += '&' + this.joinFilter(data['filter'], true)
    } else if (data['condition']) {
      url += data['condition']
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateBroadcast: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    if (data['filter']) {
      var tt = (data['filter'] = {
        ...data['filter'],
        app: 'line'
      })

      var filter = ''
      filter += this.joinFilter(tt, true)
      data.m_condition = filter
    }
    axios
      .post(config.serverUrl + 'savebroadcast', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editProductBundle: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productbundle?productbundleid=' + data.id, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteProductBundle: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'productbundle?productbundleid=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'categories', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editCategory: function(data, callback) {
    let request = {
      name: data.name
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'categories?id=' + data.id, request)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'categories?id=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteSubCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'subcategories?id=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getProductStock: function(productid, callback) {
    let url = config.serverUrl + 'productstock?productid=' + productid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editProductStock: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productstock?productstockid=' + data.id, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteProductStock: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'productstock?productstockid=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  newSubscribe: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'newsubscribe', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getUserMessages: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(
        config.serverUrl +
          'getchatlog?userid=' +
          data['userid'] +
          '&limit=' +
          data['limit'] +
          '&offset=' +
          data['offset'] +
          '&pageid=' +
          data['pageid']
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardSummary: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url =
      config.serverUrl +
      'pagereport_summary?pageid=' +
      data['pageid'] +
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto']
    if (data.app != 'all') {
      url += '&app=' + data.app
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getOrderSummary: function(data, callback) {
    var url = config.serverUrl + `ordersummary`
    var headers = {}
    if (data.pageid && data.pageid != '' && data.pageid != null) {
      // url += 'pageid=' + data['pageid']
      headers = {
        AUTHORIZATION: store.getters.securityToken
      }
    } else if (data.lineid && data.lineid != '' && data.lineid != null) {
      // url += 'lineid=' + data['lineid']
    }
    // url +=
    // '&datefrom=' + data['datefrom'] + '&dateto=' + data['dateto'] + '&status=' + data['status']

    axios
      .get(url, { params: data, headers: headers })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTraningConversation: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    // axios.defaults.timeout = 60000;
    axios
      .get(config.serverUrl + 'defaultchatlogs', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteBroadcast: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'deletebroadcast', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTutoriallist: function(callback) {
    let url = config.serverUrl + 'tutoriallist'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateTutoriallist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'tutoriallist', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getProductBundle: function(data, callback) {
    let url = config.serverUrl + 'productbundle?productid=' + data.id
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveProductBundle: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productbundle?productid=' + data.productid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getGbprime: function(data, callback) {
    let url = config.serverUrl + 'gbprime?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveGbprime: function(data, callback) {
    let url = config.serverUrl + 'gbprime?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLineToken: function(data, callback) {
    let url = config.serverUrl + 'linetoken?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveLineToken: function(data, callback) {
    let url = config.serverUrl + 'linetoken?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  checkGBprimeToken: function(data) {
    return new Promise((resolve, reject) => {
      var request = {
        token: data.token,
        amount: '1',
        referenceNo: new Date().getTime(),
        payType: 'F',
        cardUse: 'Y',
        billUse: 'Y',
        qrUse: 'Y',
        expire: '1',
        deliveryMethod: '0',
        multipleUse: 'N',
        detail: 'Check Valid Token'
      }
      axios
        .post('https://api.gbprimepay.com/gbp/gateway/link', request)
        .then(response => {
          if (response.data.gbLinkUrl !== undefined) {
            resolve()
          } else {
            reject(new Error('Something wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getPublishedPost: function(fburl) {
    return new Promise((resolve, reject) => {
      let url = null
      if (fburl && fburl != '') {
        url = fburl
      } else {
        url =
          'https://graph.facebook.com/v3.2/' +
          store.state.selectedBot.pageid +
          '/posts?access_token=' +
          store.state.selectedBot.page_access_token
      }
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getSchedulePost: function(fburl) {
    return new Promise((resolve, reject) => {
      let url = null
      if (fburl && fburl != '') {
        url = fburl
      } else {
        url =
          'https://graph.facebook.com/v3.2/' +
          store.state.selectedBot.pageid +
          '/scheduled_posts?access_token=' +
          store.state.selectedBot.page_access_token
      }
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  saveUserStatus: function(data, callback) {
    let url = config.serverUrl + 'userstatus?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getUserStatus: function(data, callback) {
    let url = config.serverUrl + 'userstatus?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserEmail: function(data, callback) {
    let url = config.serverUrl + 'useremail?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserPhoneno: function(data, callback) {
    let url = config.serverUrl + 'userphoneno?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserTags: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'usertags?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserProvince: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userprovince?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserLineId: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userlineid?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserSchool: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userschool?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getWholesaleStatus: function(data, callback) {
    let url = config.serverUrl + 'wholesale_status?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWholesaleStatus: function(data, callback) {
    let url = config.serverUrl + 'wholesale_status?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?wholesaleid=' + data.wholesaleid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?wholesaleid=' + data.wholesaleid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPauseStatus: function(data, callback) {
    let url = config.serverUrl + 'notreplyduplicateintent?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  togglePauseStatus: function(data, callback) {
    let url = config.serverUrl + 'notreplyduplicateintent?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getReplyDelay: function(data, callback) {
    let url = config.serverUrl + 'replydelay?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editReplyDelay: function(data, callback) {
    let url = config.serverUrl + 'replydelay?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLineNotify: function(data, callback) {
    let url = config.serverUrl + 'linenotify?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveLineNotify: function(data, callback) {
    let url = config.serverUrl + 'linenotify'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteLineNotify: function(data, callback) {
    let url =
      config.serverUrl + 'linenotify?pageid=' + data['pageid'] + '&adminid=' + data['adminid']
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveLineNotifyNotification: function(data, callback) {
    let url = config.serverUrl + 'notifications?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getCompareIntents: function(data, callback) {
    let url =
      config.serverUrl + 'compareintents?pageid1=' + data.pageid1 + '&pageid2=' + data.pageid2
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getSupportUser: function(data, callback) {
    let url = config.serverUrl + 'supportusers?supportusers=' + data.supportusers
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  transferIntents: function(data, callback) {
    let url = config.serverUrl + 'cloneintents?pageid1=' + data.pageid1 + '&pageid2=' + data.pageid2

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveSupportusers: function(data, callback) {
    let url = config.serverUrl + 'supportusers?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAllShipingCharge: function(data, callback) {
    let url = config.serverUrl + 'allshipingcharge?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveAllShipingCharge: function(data, callback) {
    let url = config.serverUrl + 'allshipingcharge?pageid=' + data.pageid
    delete data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  insertUsersFromInbox: function(data, callback) {
    let url = config.serverUrl + 'insertusersfrominbox?pageid=' + data.pageid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTimeToUseBot: function(data, callback) {
    let url = config.serverUrl + 'timetousebot?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveTimeToUseBot: function(data, callback) {
    let url = config.serverUrl + 'timetousebot?pageid=' + data.pageid
    delete data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getVideoList: function() {
    return new Promise((resolve, reject) => {
      let url =
        'https://graph.facebook.com/v4.0/' +
        store.state.selectedBot.pageid +
        '/video_lists?access_token=' +
        store.state.selectedBot.page_access_token
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getVideo: function(url) {
    return new Promise((resolve, reject) => {
      if (!url) {
        url =
          'https://graph.facebook.com/v4.0/' +
          store.state.selectedBot.pageid +
          '/videos?access_token=' +
          store.state.selectedBot.page_access_token +
          '&fields=permalink_url,title,description,source,id,picture,length'
      }

      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getWordAfterOrderAndCartSummary: function(data, callback) {
    let url = config.serverUrl + 'wordsafterordersandcartsummary?pageid=' + data.pageid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios

      .get(url)

      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWordAfterOrderAndCartSummary: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'wordsafterordersandcartsummary?pageid=' + data.pageid, data)

      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getUser: function(data, callback) {
    let url = config.serverUrl + 'getuser'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  activateredeemcode(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(
        config.serverUrl + 'activateredeemcode?pageid=' + data.pageid + '&redeemcode=' + data.redeem
      )
      .then(response => {
        callback(null, response.data)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putchangebotstate: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'changebotstate?pageid=' + data.pageid, data.input)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putQvalIntents: function(request, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'qvalintents', request.data, { params: request.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  // multistatusordersummary?pageid=....&orderidlist=.....&statusorder=......
  putmultistatusordersummary: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(
        config.serverUrl +
          `multistatusordersummary?pageid=${data.pageid}&orderidlist=${data.orderid}&statusorder=${data.status}`,
        data.input
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putprioritycategories: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `prioritycategories?pageid=${data.pageid}`, {
        categorieslist: data.input
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putpriorityproducts: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `priorityproducts?pageid=${data.pageid}`, {
        productslist: data.input
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getcompareshopservice: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `compareshopservice?pageid1=${data.pageid1}&pageid2=${data.pageid2}`)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  transfershopservice: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(
        config.serverUrl + `transfershopservice?pageid1=${data.pageid1}&pageid2=${data.pageid2}`,
        data
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveUserContext: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `usercontext?pageid=${data.pageid}`, {
        context: data.context,
        userid: data.usersid
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  zwizadminbotlist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `zwizadminbotlist?limit=${data.limit}&offset=${data.offset}`
    if (data.pagename) url += `&pagename=${data.pagename}`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getuserCustomer: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `getuser?pageid=${data.pageid}&userid=${data.userid}`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getInfocustomerspremium: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `infocustomerspremium?pageid=${data['pageid']}&type=${data.type}&package=${data.package}`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postInfocustomerspremium: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `infocustomerspremium?pageid=${data['pageid']}&package=${data.package}`
    axios
      .post(config.serverUrl + url, data.obj)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  collectlineidpremiumextra: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `collectlineidpremiumextra?pageid=${data['pageid']}`
    axios
      .put(config.serverUrl + url, data.obj)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  productstockadd: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productstockadd?productstockid=${data['productstockid']}`
    axios
      .put(config.serverUrl + url, { addquantity: data.quantity })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  productstockdelete: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productstockdelete?productstockid=${data['productstockid']}`
    axios
      .put(config.serverUrl + url, { deletequantity: data.quantity })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  orderstockadd: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `orderstockadd?orderid=${data['orderid']}`
    axios
      .put(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  orderstockdelete: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `orderstockdelete?orderid=${data['orderid']}`
    axios
      .put(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putauctionfbpost: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `auctionfbpost?id=${data['id']}`
    axios
      .put(config.serverUrl + url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postauctionfbpost: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `auctionfbpost`
    axios
      .post(config.serverUrl + url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getauctionfbpost: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `auctionfbpost?pageid=${data['pageid']}`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  checkChatdayToken: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'chatdaytoken', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getadminperformbypageid: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `adminperformbypageid`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getUserOnly: function(data, callback) {
    let url = config.serverUrl + 'getuseronly'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getPartnerProfile: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `partnerprofile`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getPartnerRedeemCode: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `partnerredeemcode`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getPartnerCustomers: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `partnercustomers`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getLatestSupportUsers: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `latestsupportusers`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getproductlive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productlive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putproductlive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productlive', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postproductlive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productlive', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postliveinfo: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'liveinfo', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postsendordersummaryall: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'sendordersummaryall', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putchangeproductlivestatus: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'changeproductlivestatus', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postsendordersummarybyuser: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'sendordersummarybyuser', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postproductstocklive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productstocklive', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putliveinfo: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'liveinfo', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putproductstocklive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productstocklive', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putcartsummarypattern: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'cartsummarypattern', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putcartsummarypatternstatus: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'cartsummarypatternstatus', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postuploadcentralproducts: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'uploadcentralproducts', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteproductlive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productlive`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteproductstocklive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productstocklive`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getliveinfo: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `liveinfo`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getuserCustomerOnly: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `getuseronly?pageid=${data.pageid}&userid=${data.userid}`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getliveinfodetail: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `liveinfodetail`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getchatstat: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `chatstat`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getorderstat: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `orderstat`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  gettoporderslive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `toporderslive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getordersummarylive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `ordersummarylive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getexportcmsviewcarts: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `exportcmsviewcarts`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteliveinfo: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `liveinfo`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getusercartslive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `usercartslive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getcartsummarypattern: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `cartsummarypattern`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteclearcartslive: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `clearcartslive`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getcmsviewcarts: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `cmsviewcarts`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getusercart: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `usercart`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  postUsersmanual: function(data, callback) {
    axios
      .post(config.serverUrl + 'usersmanual', data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putUsersmanual: function(data, callback) {
    axios
      .put(config.serverUrl + 'usersmanual', data.data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getTickets: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `tickets`, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTicketById: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `ticketsbyid`, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getTicketByAdminId: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `ticketsbyadminid`, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTicketListByUser: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `ticketsbyuserid`, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  postTickets: function(data, callback) {
    axios
      .post(config.serverUrl + 'tickets', data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  putTickets: function(data, callback) {
    axios
      .put(config.serverUrl + 'tickets', data.data, {
        params: data.params,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAdminGroup: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    if (data.isCentral) {
      var url = 'uploadcentralproducts'
    } else {
      var url = 'uploadzwizproducts'
    }
    axios
      .get(config.serverUrl + `admingroup`, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getordersbyid: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `ordersbyid`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAdminSubGroup: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `adminsubgroup`, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveSlip: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    axios
      .put(config.serverUrl + 'ordersummarynote', data.data, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAdmins: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `adminuser`, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAdminsById: function(id, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `adminuser/${id}`)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTicketsByAgent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `ticketsbyagent`, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTicketsByStatus: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `ticketsbystatus`, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  postadmingroup: function(data, callback) {
    axios
      .post(config.serverUrl + `admingroup`, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  putadmingroup: function(data, callback) {
    axios
      .put(config.serverUrl + `admingroup`, data.data, {
        params: data.params,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteadmingroup: function(data, callback) {
    axios
      .delete(config.serverUrl + `admingroup`, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  postadminsubgroup: function(data, callback) {
    axios
      .post(config.serverUrl + `adminsubgroup`, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  putadminsubgroup: function(data, callback) {
    axios
      .put(config.serverUrl + `adminsubgroup`, data.data, {
        params: data.params,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteadminsubgroup: function(data, callback) {
    axios
      .delete(config.serverUrl + `adminsubgroup`, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteAllInCart(data, callback) {
    axios
      .delete(config.serverUrl + 'cmsviewcarts', {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        data: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  async sendmailforgetpassword(email) {
    const headers = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'sendmailforgetpassword'
    try {
      let res = await axios.post(url, { email }, { headers })
      if (res.data.responsecode) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },

  createadminuser(data, callback) {
    axios
      .post(config.serverUrl + `createadminuser`, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteadminusers(data, callback) {
    axios
      .delete(config.serverUrl + 'adminusers', {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        data: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  changeprivilegeadminuser(data, callback) {
    axios
      .put(config.serverUrl + `changeprivilegeadminuser`, data.data, {
        params: data.params,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  changeticketpasswordadminuser(data, callback) {
    axios
      .put(config.serverUrl + `changepasswordadminuser`, data.data, {
        params: data.params,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getgetstartedmenu: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `getstarted_menu`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  savegetstartedmenu: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'getstarted_menu', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserAddress: function(data, callback) {
    let url = config.serverUrl + 'useraddress?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  savefbpaystatus(data, callback) {
    let url = config.serverUrl + 'fbpaystatus'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  adminreadchat(data, callback) {
    let url = config.serverUrl + 'adminreadchat'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getpromotioncode: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `promotioncode`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  savepromotioncode(data, callback) {
    let url = config.serverUrl + 'promotioncode'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data.data, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editpromotioncode: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'promotioncode', data.data, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deletepromotioncode(data, callback) {
    axios
      .delete(config.serverUrl + 'promotioncode', {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getchatlogthaiunionformat(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `chatlogthaiunionformat`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  livechatnotiunread(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `livechatnotiunread`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getbranchlocation(data, callback) {
    let url = `branchlocation`
    axios
      .get(config.serverUrl + url, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  savebranchlocation(data, callback) {
    let url = config.serverUrl + 'branchlocation'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  savebranchlocation(data, callback) {
    let url = config.serverUrl + 'branchlocation'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getGroupDefaultChatlogs: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    // axios.defaults.timeout = 60000;
    axios
      .get(config.serverUrl + 'groupdefaultchatlogs', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getshippop(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shippop', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveshippop(data, callback) {
    let url = config.serverUrl + 'shippop'
    axios
      .put(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  shippopcheckorderlist(data, callback) {
    let url = config.serverUrl + 'shippopcheckorderlist'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  shippopbooking(data, callback) {
    let url = config.serverUrl + 'shippopbooking'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  shippopconfirm(data, callback) {
    let url = config.serverUrl + 'shippopconfirm'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  shippopbookingrefno(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shippopbookingrefno', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getgbprimecredit(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'gbprimecredit', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  savegbprimecredit(data, callback) {
    let url = config.serverUrl + 'gbprimecredit'
    axios
      .put(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  putassignstatusByadminid(data, callback) {
    let url = config.serverUrl + 'assignstatusByadminid'
    axios
      .put(url, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  gbcreaterefnofromupgradepremiumcms(data, callback) {
    let url = config.serverUrl + 'gbcreaterefnofromupgradepremiumcms'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params,
        responseType: 'arraybuffer'
      })
      .then(response => {
        callback(null, response)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  linemessagecontenttypefile(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'linemessagecontenttypefile', { params: data })
      .then(response => {
        callback(null, response)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  bangkokbankapplicantall(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'bangkokbankapplicantall', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getdepamemberinfoall(data, callback) {
    let url = config.serverUrl + 'depamemberinfoall'
    data.membertype_id = data.type
    data.status = data.status2
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getdepamember(data, callback) {
    let url = config.serverUrl + 'getdepamember'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getdepamembertypeall(data, callback) {
    let url = config.serverUrl + 'depamembertypeall'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  async getcampaignwithagency(params) {
    let url = config.serverUrl + 'getcampaignwithagency'
    try {
      let res = await axios.get(url, { params })
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getCouponLog(id) {
    let url = config.serverUrl + 'couponLog/' + id
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getproductApproveLog(id) {
    let url = config.serverUrl + 'productApproveLog/' + id
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async top10Product() {
    let url = config.serverUrl + 'top10product'
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getCampaign() {
    let url = config.serverUrl + 'getCampaign'
    try {
      let res = await axios.get(url, {
        params: {
          channel: 'cms'
        }
      })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async countCouponStatus() {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'countCouponStatus'
    try {
      let res = await axios.get(url, { header })
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getProjectByMemberid(memberid) {
    let url = config.serverUrl + 'getProjectByMemberid?memberid=' + memberid
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.get(url, { header })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getApplicantLog(id) {
    let url = config.serverUrl + 'getprojectapplicantlog/' + id
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.get(url, { header })
      if (res.data.responsecode == 200) {
        return res.data.data
      } else {
        return res.data.reason ? res.data.reason : ''
      }
    } catch (error) {
      console.error(error)
    }
  },
  async editDepaMember(data) {
    let url = config.serverUrl + 'cms/editDepaMemberInfo'
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.put(url, data, { header })
      if (res.data.responsecode == 200) {
        return res.data.responsecode
      } else {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getOdooData(id) {
    let url = config.serverUrl + `odooData/${id}`
    let headers = {
      AUTHORIZATION: 'BEARER XXX XXX'
    }
    try {
      let res = await axios.get(url, { headers })
      // console.log('getOdooData : ', res)
      if (res.data.responsecode == 200 && res.data) {
        return res.data
      } else {
        return null
      }
    } catch (error) {
      return null
      console.error(error)
    }
  },
  async countCouponStatusWithFilter(params) {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'countCouponStatus'
    try {
      let res = await axios.get(url, { header, params })
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getCouponConfig() {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'getCouponConfig'
    try {
      let res = await axios.get(url, { header })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getProductConfig() {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'getProductConfig'
    try {
      let res = await axios.get(url, { header })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getTapLinkConfig() {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'getTapLinkConfig'
    try {
      let res = await axios.get(url, { header })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async gettafficReport() {
    let url = config.serverUrl + 'gettafficReport/'
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.get(url, { header })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getTopProduct(limit) {
    let url = config.serverUrl + 'getTopProduct/' + limit
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.get(url, { header })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async updateProductConfig(data) {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'updateProductConfig'
    try {
      let res = await axios.post(url, data, { header })
      if (res.data && res.data.responsecode) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getStepList(id) {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'getStepList/' + id
    try {
      let res = await axios.get(url, { header })
      if (res.data && res.data.responsecode == 200) {
        return res.data.data
      } else if (res.data.reason) {
        return res.data.reason
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
    }
  },
  async updateCouponConfig(data) {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'updateCouponConfig'
    try {
      let res = await axios.post(url, data, { header })
      console.log(res.data)
      if (res.data && res.data.responsecode) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },
  async updateTapLinkConfig(data) {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'updateTapLinkConfig'
    try {
      let res = await axios.post(url, data, { header })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async deletejobD2u(id) {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'depaJobD2u/' + id
    try {
      let res = await axios.delete(url, { header })
      if (res.data.responsecode == 200) {
        return res.data.responsecode
      } else {
        res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },
  async createdepacampaign(data) {
    return new Promise(async resolve => {
      let url = config.serverUrl + 'createdepacampaign'
      try {
        let res = await axios.post(url, data)

        resolve(res.data.responsecode)
      } catch (error) {
        console.error(error)
        resolve()
      }
    })
  },
  async createProduct_badges(data) {
    return new Promise(async resolve => {
      let url = config.serverUrl + 'createProduct_badges'
      try {
        let res = await axios.post(url, data)

        resolve(res.data.responsecode)
      } catch (error) {
        console.error(error)
        resolve()
      }
    })
  },
  async updatedepacampaign(data) {
    return new Promise(async resolve => {
      let url = config.serverUrl + 'updatedepacampaign'
      try {
        let res = await axios.post(url, data)

        resolve(res.data.responsecode)
      } catch (error) {
        console.error(error)
        resolve()
      }
    })
  },
  async deletedepacampaign(id) {
    return new Promise(async resolve => {
      let url = config.serverUrl + `deletedepacampaign/${id}`
      try {
        let res = await axios.delete(url)
        if (res.data.responsecode == 204) {
          resolve(res.data.responsecode)
        }
      } catch (error) {
        console.error(error)
        resolve()
      }
    })
  },
  postdepamembertype(data, callback) {
    let url = config.serverUrl + 'depamembertype'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putdepamembertype(data, callback) {
    let url = config.serverUrl + 'depamembertype'
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  createdepaprojectform(data, callback) {
    let url = config.serverUrl + 'createdepaprojectform'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getdepaprojectform(data, callback) {
    let url = config.serverUrl + 'getdepaprojectform'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  async deletedepaprojectform(id) {
    let url = config.serverUrl + 'deletedepaprojectform'
    try {
      let res = await axios.delete(url, { params: id })
      return res
    } catch (error) {
      console.error(error)
      return false
    }
  },
  // deletedepaprojectform(data, callback) {
  //   let url = config.serverUrl + 'deletedepaprojectform'
  //   axios
  //     .delete(url, { params: data })
  //     .then(response => {
  //       this.defaultResponse(response, callback)
  //     })
  //     .catch(e => {
  //       this.defaultError(e, callback)
  //     })
  // },
  createdepaprojectform(data, callback) {
    let url = config.serverUrl + 'createdepaprojectform'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  updatedepaprojectform(data, callback) {
    let url = config.serverUrl + 'updatedepaprojectform'
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getdepaprojecttype(data, callback) {
    let url = config.serverUrl + 'getdepaprojecttype'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getdepaproject(data, callback) {
    let url = config.serverUrl + 'getdepaproject'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getProjectByAgencyList(data, callback) {
    let url = config.serverUrl + 'getProjectByAgencyList'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deletedepaprojecttype(data, callback) {
    let url = config.serverUrl + 'deletedepaprojecttype'
    axios
      .delete(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  // deletedepaproject(data, callback) {
  //   let url = config.serverUrl + 'deletedepaproject'
  //   axios
  //     .delete(url, { params: data })
  //     .then(response => {
  //       this.defaultResponse(response, callback)
  //     })
  //     .catch(e => {
  //       this.defaultError(e, callback)
  //     })
  // },
  async deletedepaproject(id) {
    let url = config.serverUrl + 'deletedepaproject'
    try {
      let res = await axios.delete(url, { params: id })
      return res
    } catch (error) {
      console.error(error)
      return false
    }
  },
  getdepaprojectapplicant(data, callback) {
    let url = config.serverUrl + 'getdepaprojectapplicant'
    data.membertype_id = data.type
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  async getExcelReport(data) {
    let url = config.serverUrl + 'getdepaprojectapplicant'
    data.membertype_id = data.type
    try {
      let res = await axios.get(url, { params: data, responseType: 'blob' })
      return res.data
    } catch (error) {
      console.error(error)
      return false
    }
  },
  getdepaprojectapplicantexport(data, callback) {
    let url = config.serverUrl + 'getdepaprojectapplicantexport'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depausersregisterbydate(data, callback) {
    let url = config.serverUrl + 'depausersregisterbydate'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depausersregisterbymembertype(data, callback) {
    let url = config.serverUrl + 'depausersregisterbymembertype'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depausersapplyprojectapplicantsbystatus(data, callback) {
    let url = config.serverUrl + 'depausersapplyprojectapplicantsbystatus'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depatopfiveusersapplyproject(data, callback) {
    let url = config.serverUrl + 'depatopfiveusersapplyproject'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depajobd2ualljobsdashboard(data, callback) {
    let url = config.serverUrl + 'depajobd2ualljobsdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depajobd2ubyjobiddashboard(data, callback) {
    let url = config.serverUrl + 'depajobd2ubyjobiddashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depajobd2ucategoryitdashboard(data, callback) {
    let url = config.serverUrl + 'depajobd2ucategoryitdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depajobd2ucategorynonitdashboard(data, callback) {
    let url = config.serverUrl + 'depajobd2ucategorynonitdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depadeletemembertypebyid(data, callback) {
    let url = config.serverUrl + 'depadeletemembertypebyid'
    axios
      .delete(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depausersapplyprojectapplicants(data, callback) {
    let url = config.serverUrl + 'depausersapplyprojectapplicants'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depacheckprojectusedtypebyid(data, callback) {
    let url = config.serverUrl + 'depacheckprojectusedtypebyid'
    axios
      .get(url, { params: data })
      .then(response => {
        // callback(null, response)
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postdepajobd2uadmincreatejob(data, callback) {
    let url = config.serverUrl + 'depajobd2uadmincreatejob'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putdepajobd2uadminupdatejob(data, callback) {
    let url = config.serverUrl + 'depajobd2uadminupdatejob'
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  createdepaprojecttype(data, callback) {
    let url = config.serverUrl + 'createdepaprojecttype'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  updatedepaprojecttype(data, callback) {
    let url = config.serverUrl + 'updatedepaprojecttype'
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  createdepaproject(data, callback) {
    let url = config.serverUrl + 'createdepaproject'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  // deparesendnotifyformbystepid(data, callback) {
  //   let url = config.serverUrl + 'deparesendnotifyformbystepid'
  //   axios
  //     .post(url, data)
  //     .then(response => {
  //       this.defaultResponse(response, callback)
  //     })
  //     .catch(e => {
  //       this.defaultError(e, callback)
  //     })
  // },
  async getfinancial(data) {
    let url = config.serverUrl + 'dbd/financial'
    try {
      let resdata = await axios.post(url, data)
      if (resdata && resdata.data) {
        return resdata.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
    }
  },
  async checkdoae(data) {
    let url = config.serverUrl + 'checkdoae?id_card=' + data
    try {
      let resdata = await axios.get(url)
      if (
        resdata &&
        resdata.data &&
        resdata.data.responsecode == 200 &&
        resdata.data.data.status &&
        resdata.data.data.data
      ) {
        return resdata.data.data.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getshareholder(data) {
    let url = config.serverUrl + 'dbd/shareholder'
    try {
      let resdata = await axios.post(url, data)
      if (resdata && resdata.data) {
        return resdata.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getshareholderPDF(data) {
    let url = config.serverUrl + 'dbd/shareholderpdf'
    try {
      let resdata = await axios.post(url, data)
      if (resdata && resdata.data) {
        return resdata.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getshareholderDownloadPDF(data) {
    let url = config.serverUrl + 'dbd/shareholderpdf/download'
    try {
      
      let resdata = await axios.post(url, data)
      if (resdata && resdata.data) {        
        return resdata.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getinformationPDF(data) {
    let url = config.serverUrl + 'dbd/informationpdf'
    try {
      let resdata = await axios.post(url, data)
      if (resdata && resdata.data) {
        return resdata.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getborikonPDF(data) {
    let url = config.serverUrl + 'dbd/borikonpdf'
    try {
      let resdata = await axios.post(url, data)
      if (resdata && resdata.data) {
        return resdata.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getAgency() {
    let url = config.serverUrl + 'getAgency'
    try {
      let resdata = await axios.post(url)
      if (resdata && resdata.data) {
        return resdata.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getAgencyOpen() {
    let url = config.serverUrl + 'getAgencyOpen'
    try {
      let resdata = await axios.post(url)
      if (resdata && resdata.data) {
        return resdata.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getAgencyClose() {
    let url = config.serverUrl + 'getAgencyClose'
    try {
      let resdata = await axios.post(url)
      if (resdata && resdata.data) {
        return resdata.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
    }
  },
  depasendreport(data, callback) {
    let url = config.serverUrl + 'depasendreport'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  updatedepaproject(data, callback) {
    let url = config.serverUrl + 'updatedepaproject'
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depaadminrejectmemberregister(data, callback) {
    let url = config.serverUrl + 'depaadminrejectmemberregister'
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depaUpdateStatusMemberRejectToConfirm(data, callback) {
    let url = config.serverUrl + 'depaUpdateStatusMemberRejectToConfirm'
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  depaUpdateStatusSME(data, callback) {
    let url = config.serverUrl + 'depamembersme'
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  // =============== default function =================

  defaultResponse: function(response, callback) {
    // store.dispatch('logout', { 'code': '400', 'message': 'Session expire. Please login again.'  }).then(function(){
    // 	router.push('/login')

    // })
    response = response.data
    if (response.responsecode === 200) {
      callback(null, response)
    } else if (response.responsecode == 300) {
      Vue.swal.fire({ text: response.reason })
    } else if (response.responsecode === 400) {
      let message = response.reason ? response.reason : ''
      var isFacebook = store.state.isFacebook

      // console.log('before',isFacebook)
      store.dispatch('logout', { code: response.responsecode, message: message }).then(function() {
        // console.log('after', isFacebook)
        if (router.history.current.name !== 'login' || router.history.current.name !== 'nigol') {
          // console.log(router.history.current.name)
          if (isFacebook) {
            router.push({
              path: '/' + store.getters.currentLang + '/nigol',
              query: router.query
            })
          } else {
            router.push({
              path: '/' + store.getters.currentLang + '/nigol',
              query: router.query
            })
          }
        }

        callback(new Error('Session expire. Please login again.'))
      })
    } else {
      // console.log(response)
      if (response.reason) {
        callback(new Error(response.reason))
      } else {
      }
    }
  },

  getshopaddressarray(data, callback) {
    let url = config.serverUrl + 'shopaddressarray'
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveshopaddressarray(data, callback) {
    let url = config.serverUrl + 'shopaddressarray'
    axios
      .put(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postgpkmemberdashboard(data, callback) {
    let url = config.serverUrl + 'gpkmemberdashboard'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postgpkmemberregisterdashboard(data, callback) {
    let url = config.serverUrl + 'gpkmemberregisterdashboard'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postgpkdiscountusagehistorydashboard(data, callback) {
    let url = config.serverUrl + 'gpkdiscountusagehistorydashboard'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  post_total_users(data, callback) {
    let url = config.serverUrl + 'total_users'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  putuserrealname(data, callback) {
    let url = config.serverUrl + 'userrealname'
    axios
      .put(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putusercardnumber(data, callback) {
    let url = config.serverUrl + 'usercardnumber'
    axios
      .put(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  employeelogindashboard(data, callback) {
    let url = config.serverUrl + 'employeelogindashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  employeefilterinfo(data, callback) {
    let url = config.serverUrl + 'employeefilterinfo'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_total_users_calculate(data, callback) {
    let url = config.serverUrl + 'total_users_calculate'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_total_new_users(data, callback) {
    let url = config.serverUrl + 'total_new_users'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_report_inbox_user_by_date(data, callback) {
    let url = config.serverUrl + 'report_inbox_user_by_date'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_report_comment_user_by_date(data, callback) {
    let url = config.serverUrl + 'report_comment_user_by_date'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  post_report_inbox_user_by_time(data, callback) {
    let url = config.serverUrl + 'report_inbox_user_by_time'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  post_report_comment_user_by_time(data, callback) {
    let url = config.serverUrl + 'report_comment_user_by_time'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  post_report_inbox_message(data, callback) {
    let url = config.serverUrl + 'report_inbox_message'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  post_report_comment_message(data, callback) {
    let url = config.serverUrl + 'report_comment_message'
    axios
      .post(url, data.body, { params: data.params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_all_users(data, callback) {
    let url = config.serverUrl + 'all_users'
    axios
      .post(url, data.body, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  post_all_users_calculate(data, callback) {
    let url = config.serverUrl + 'all_users_calculate'
    axios
      .post(url, data.body, {
        params: data.params
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  customerrequestquotationdashboard(data, callback) {
    let url = config.serverUrl + 'customerrequestquotationdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  dealersendquotationdashboard(data, callback) {
    let url = config.serverUrl + 'dealersendquotationdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  orderscompletepaymentdashboard(data, callback) {
    let url = config.serverUrl + 'orderscompletepaymentdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  ordersshippingdashboard(data, callback) {
    let url = config.serverUrl + 'ordersshippingdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  dealerregistersuccessdashboard(data, callback) {
    let url = config.serverUrl + 'dealerregistersuccessdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  provincedealerdashboard(data, callback) {
    let url = config.serverUrl + 'provincedealerdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  provinceofdealerquotationdashboard(data, callback) {
    let url = config.serverUrl + 'provinceofdealerquotationdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  ordersummarywithoutshippingdashboard(data, callback) {
    let url = config.serverUrl + 'ordersummarywithoutshippingdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  painterregistersuccessdashboard(data, callback) {
    let url = config.serverUrl + 'painterregistersuccessdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  provincepainterdashboard(data, callback) {
    let url = config.serverUrl + 'provincepainterdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  provinceofsearchpainterdashboard(data, callback) {
    let url = config.serverUrl + 'provinceofsearchpainterdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  searchpainterdashboard(data, callback) {
    let url = config.serverUrl + 'searchpainterdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  painterconfirmjobdashboard(data, callback) {
    let url = config.serverUrl + 'painterconfirmjobdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  painterreviewjobdashboard(data, callback) {
    let url = config.serverUrl + 'painterreviewjobdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  paintersendstartdatejobdashboard(data, callback) {
    let url = config.serverUrl + 'paintersendstartdatejobdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  paintercanceledjobdashboard(data, callback) {
    let url = config.serverUrl + 'paintercanceledjobdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  painterupdatejobdashboard(data, callback) {
    let url = config.serverUrl + 'painterupdatejobdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  channeltoquotationpaintersdashboard(data, callback) {
    let url = config.serverUrl + 'channeltoquotationpaintersdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  channeltoquotationdealerdashboard(data, callback) {
    let url = config.serverUrl + 'channeltoquotationdealerdashboard'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getDepaAgencyMaster(data, callback) {
    let url = config.serverUrl + 'cms/getDepaAgencyMaster'
    axios
      .get(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteDepaAgencyMaster(data, callback) {
    let url = config.serverUrl + 'cms/deleteDepaAgencyMaster'
    axios
      .delete(url, { params: data })
      .then(response => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  createDepaAgencyMaster(data, callback) {
    let url = config.serverUrl + 'cms/createDepaAgencyMaster'
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  updateDepaAgencyMaster(data, callback) {
    let url = config.serverUrl + 'cms/updateDepaAgencyMaster'
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  // end
  // =============== default function =================

  defaultResponse: function(response, callback) {
    // store.dispatch('logout', { 'code': '400', 'message': 'Session expire. Please login again.'  }).then(function(){
    // 	router.push('/login')

    // })
    response = response.data
    if (response.responsecode === 200) {
      callback(null, response)
    } else if (response.responsecode === 400) {
      let message = response.reason ? response.reason : ''
      var isFacebook = store.state.isFacebook

      // console.log('before',isFacebook)
      store.dispatch('logout', { code: response.responsecode, message: message }).then(function() {
        // console.log('after', isFacebook)
        if (router.history.current.name !== 'login' || router.history.current.name !== 'nigol') {
          // console.log(router.history.current.name)
          if (isFacebook) {
            router.push({
              path: '/' + store.getters.currentLang + '/nigol',
              query: router.query
            })
          } else {
            router.push({
              path: '/' + store.getters.currentLang + '/nigol',
              query: router.query
            })
          }
        }

        callback(new Error('Session expire. Please login again.'))
      })
    } else {
      // console.log(response)

      // Vue.swal.fire({ text: response.reason })
      Vue.swal.fire({
        type: 'error',
        title: `<div class="headline primary--text bold7 fs-24">${response.reason}</div>`,
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
      })
      if (response.reason) {
        callback(new Error(response.reason))
      } else {
      }
    }
  },

  defaultError: function(e, callback) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(e)
    }
    callback(new Error('Session expire. Please login again.'))
  },

  async getCategory(params) {
    let url = config.serverUrl + 'getdepacategory'
    try {
      let res = await axios.get(url, { params })
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },

  async deletemember(memberid) {
    let url = config.serverUrl + `cms/depamember/${memberid}`
    try {
      let res = await axios.delete(url)
      if (res.data.responsecode == 200) {
        return true
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },

  async createCategory(obj) {
    let url = config.serverUrl + 'createdepacategory'
    try {
      let res = await axios.post(url, obj)
      if (res.data.responsecode == 204) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },

  async updateCategory(id, obj) {
    let url = config.serverUrl + `updatedepacategory/${id}`
    try {
      let res = await axios.put(url, obj)
      if (res.data.responsecode == 204) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },

  async deleteCategory(id) {
    let url = config.serverUrl + `deletedepacategory/${id}`
    try {
      let res = await axios.delete(url)
      if (res.data.responsecode == 204) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },

  async getType(params) {
    let url = config.serverUrl + 'getdepatype'
    try {
      let res = await axios.get(url, { params })
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },

  async createType(obj) {
    let url = config.serverUrl + 'createdepatype'
    try {
      let res = await axios.post(url, obj)
      if (res.data.responsecode == 204) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },

  async updateType(id, obj) {
    let url = config.serverUrl + `updatedepatype/${id}`
    try {
      let res = await axios.put(url, obj)
      if (res.data.responsecode == 204) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },

  async deleteType(id) {
    let url = config.serverUrl + `deletedepatype/${id}`
    try {
      let res = await axios.delete(url)
      if (res.data.responsecode == 204) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },
  async createTag(obj) {
    let url = config.serverUrl + 'producttag'
    try {
      let res = await axios.post(url, obj)
      if (res.data.responsecode == 200) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },

  async updateTag(id, obj) {
    let url = config.serverUrl + `producttag/${id}`
    try {
      let res = await axios.patch(url, obj)
      if (res.data.responsecode == 200) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },

  async deleteTag(id) {
    let url = config.serverUrl + `producttag/${id}`
    try {
      let res = await axios.delete(url)
      if (res.data.responsecode == 200 || res.data.responsecode == 400) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },

  async getCouponReport(params) {
    let url = config.serverUrl + `getCouponReport`
    try {
      let res = await axios.post(url, params)
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },

  async updateProductApprove(productid, approve, rejectmessage) {
    let url = config.serverUrl + `updateProductApprove`
    let data = {
      productid,
      approve: approve ? approve : 'pending',
      rejectmessage
    }
    try {
      let res = await axios.post(url, data)
      if (res.data.responsecode == 204) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },
  async updateProductSkillApprove(productid, approve, rejectmessage) {
    let url = config.serverUrl + `updateProductSkillApprove`
    let data = {
      productid,
      approve: approve ? approve : 'pending',
      rejectmessage
    }
    try {
      let res = await axios.post(url, data)
      if (res.data.responsecode == 204) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },
  async updateProductDoc(productid, doc_url) {
    let url = config.serverUrl + `updateProductDoc`
    let data = {
      productid,
      doc_url
    }
    try {
      let res = await axios.post(url, data)
      if (res.data.responsecode == 204) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },

  async updateCoupon(id, data) {
    let url = config.serverUrl + `updateCoupon/${id}`
    try {
      let res = await axios.patch(url, data)
      if (res.data.responsecode == 204 || res.data.responsecode == 300) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },

  async getCountAllProducts(params) {
    let url = config.serverUrl + `countAllProducts`
    try {
      let res = await axios.get(url, { params })
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getCountAllProductSkill(params) {
    let url = config.serverUrl + `countAllProductSkill`
    try {
      let res = await axios.get(url, { params })
      if (res.data.responsecode == 200) {             
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getProductReport(body) {
    let url = config.serverUrl + `getProduct`
    try {
      let res = await axios.post(url, body)
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getProductSkillReport(body) {
    let url = config.serverUrl + `getProductSkill`
    try {
      let res = await axios.post(url, body)
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getAllProductReport(body) {
    let url = config.serverUrl + `getProduct`
    try {
      let res = await axios.post(url, body)
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getAgencyWithCampaign(params) {
    let url = config.serverUrl + `getAgencyWithCampaign`
    try {
      let res = await axios.get(url, { params })
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },

  async getProvinceCouponStat(params) {
    let url = config.serverUrl + `getProvinceCouponStat`
    try {
      let res = await axios.get(url, { params })
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },

  async deleteApplicant(id) {
    let url = config.serverUrl + 'deleteApplicant/' + id
    try {
      let res = await axios.delete(url)
      return res
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async customFormByStepid(id) {
    let url = config.serverUrl + 'customFormByStepid/' + id
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },

  async depafirstAllowMember() {
    let url = config.serverUrl + 'depafirstAllowMember'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },

  joinFilter: function(data, isPremium) {
    var url = []
    if (data['gender']) {
      url.push('gender=' + data['gender'].value)
    }
    if (data['fullname']) {
      url.push('fullname=' + data['fullname'])
    }
    if (data['app']) {
      if (data['app'] !== 'all') {
        url.push('app=' + data['app'])
      }
    }
    if (data['locale'] && data['locale'].length > 0) {
      var locales = []
      if (data['locale']) {
        data['locale'].map(function(locale, index) {
          locales.push(locale.value)
        })
      }
      url.push('locale=' + locales.join(','))
    }
    if (data['tags']) {
      url.push('tags=' + data['tags'])
    }
    if (data['membername']) {
      url.push('membername=' + data['membername'])
    }
    if (data['membertype']) {
      url.push('membertype=' + data['membertype'])
    }
    if (data['memberstatus']) {
      url.push('memberstatus=' + data['memberstatus'])
    }
    if (data['dpType']) {
      url.push('dpType=' + data['dpType'])
    }

    if (data['projectname']) {
      url.push('projectname=' + data['projectname'])
    }
    if (data['projecttype']) {
      url.push('projecttype=' + data['projecttype'])
    }
    if (data['statustype']) {
      url.push('statustype=' + data['statustype'])
    }
    if (data['activeDate']['start']) {
      url.push('timestamp_from=' + moment(data['activeDate']['start']).format('YYYY-MM-DD'))
    }
    if (data['activeDate'] && data['activeDate']['end']) {
      url.push('timestamp_to=' + moment(data['activeDate']['end']).format('YYYY-MM-DD'))
    }
    if (data['registerDate'] && data['registerDate']['start']) {
      url.push(
        'registertimestamp_from=' + moment(data['registerDate']['start']).format('YYYY-MM-DD')
      )
    }
    if (data['registerDate'] && data['registerDate']['end']) {
      url.push('registertimestamp_to=' + moment(data['registerDate']['end']).format('YYYY-MM-DD'))
    }
    if (data['lineid']) {
      url.push('lineid=' + data['lineid'])
    }
    if (data['school']) {
      url.push('school=' + data['school'].name)
    }
    if (data['realname']) {
      url.push('realname=' + data['realname'])
    }
    if (data['province']) {
      url.push('province=' + data['province'])
    }
    if (data['uu_register_status']) {
      url.push('uu_register_status=' + data['uu_register_status'])
    }
    if (data['uu_name']) {
      url.push('uu_name=' + data['uu_name'])
    }
    if (data['uu_dma']) {
      url.push('uu_dma=' + data['uu_dma'])
    }
    if (data['uu_areaname']) {
      url.push('uu_areaname=' + data['uu_areaname'])
    }

    if (data['specialcondition']) {
      url.push('specialcondition=' + data['specialcondition'].value)
    }

    if (isPremium) {
      if (data['email']) {
        url.push('email=' + data['email'])
      }
      if (data['context']) {
        url.push('context=' + data['context'])
      }
      if (data['phoneno']) {
        url.push('phoneno=' + data['phoneno'])
      }
      if (data['status'] && data['status'].length > 0) {
        url.push('status=' + data['status'])
      }
      if (data['intent'] && data['intent'].length > 0) {
        url.push('intent=' + data['intent'].join(','))
      }
      if (data['timezone'] && (data['timezone']['from'] || data['timezone']['to'])) {
        var timezone = []
        if (data['timezone']['from']) {
          timezone.push(data['timezone']['from'])
        }
        if (data['timezone']['to']) {
          timezone.push(data['timezone']['to'])
        }
        url.push('timezone=' + timezone.join(','))
      }
    }

    return url.join('&')
  },
  joinFilterToObject: function(data, isPremium) {
    var filter = {}
    if (data['gender']) {
      Object.assign(filter, { gender: data['gender'].value })
    }
    if (data['fullname']) {
      Object.assign(filter, { fullname: data['fullname'] })
    }
    if (data['app']) {
      if (data['app'].value !== 'all') {
        Object.assign(filter, { app: data['app'].value })
      }
    }
    if (data['locale'] && data['locale'].length > 0) {
      var locales = []
      if (data['locale']) {
        data['locale'].map(function(locale, index) {
          locales.push(locale.value)
        })
      }
      Object.assign(filter, { locale: locales.join(',') })
    }
    if (data['tags']) {
      Object.assign(filter, { tags: data['tags'] })
    }
    if (data['activeDate'] && data['activeDate']['start']) {
      Object.assign(filter, {
        timestamp_from: moment(data['activeDate']['start']).format('YYYY-MM-DD')
      })
    }
    if (data['activeDate'] && data['activeDate']['end']) {
      Object.assign(filter, {
        timestamp_to: moment(data['activeDate']['end']).format('YYYY-MM-DD')
      })
    }
    if (data['registerDate'] && data['registerDate']['start']) {
      Object.assign(filter, {
        registertimestamp_from: moment(data['registerDate']['start']).format('YYYY-MM-DD')
      })
    }
    if (data['registerDate'] && data['registerDate']['end']) {
      Object.assign(filter, {
        registertimestamp_to: moment(data['registerDate']['end']).format('YYYY-MM-DD')
      })
    }
    if (data['lineid']) {
      Object.assign(filter, { lineid: data['lineid'] })
    }
    if (data['school']) {
      Object.assign(filter, { school: data['school'].name })
    }
    if (data['province']) {
      Object.assign(filter, { province: data['province'] })
    }

    if (data['realname']) {
      Object.assign(filter, { realname: data['realname'] })
    }
    if (data['membername']) {
      Object.assign(filter, { membername: data['membername'] })
    }
    if (data['membertype']) {
      Object.assign(filter, { membertype: data['membertype'] })
    }
    if (data['memberstatus']) {
      Object.assign(filter, { memberstatus: data['memberstatus'] })
    }
    if (data['dpType']) {
      Object.assign(filter, { dpType: data['dpType'] })
    }
    if (data['projectname']) {
      Object.assign(filter, { projectname: data['projectname'] })
    }
    if (data['projecttype']) {
      Object.assign(filter, { projecttype: data['projecttype'] })
    }
    if (data['statustype']) {
      Object.assign(filter, { statustype: data['statustype'] })
    }

    if (data['uu_register_status']) {
      Object.assign(filter, { uu_register_status: data['uu_register_status'] })
    }
    if (data['uu_name']) {
      Object.assign(filter, { uu_name: data['uu_name'] })
    }
    if (data['uu_dma']) {
      Object.assign(filter, { uu_dma: data['uu_dma'] })
    }
    if (data['uu_areaname']) {
      Object.assign(filter, { uu_areaname: data['uu_areaname'] })
    }

    if (data['specialcondition']) {
      Object.assign(filter, { specialcondition: data['specialcondition'].value })
    }

    if (isPremium) {
      if (data['email']) {
        Object.assign(filter, { email: data['email'] })
      }
      if (data['context']) {
        Object.assign(filter, { context: data['context'] })
      }
      if (data['phoneno']) {
        Object.assign(filter, { phoneno: data['phoneno'] })
      }
      if (data['status'] && data['status'].length > 0) {
        Object.assign(filter, { status: data['status'] })
      }
      if (data['intent'] && data['intent'].length > 0) {
        Object.assign(filter, { intent: data['intent'].join(',') })
      }
      if (data['timezone'] && (data['timezone']['from'] || data['timezone']['to'])) {
        var timezone = []
        if (data['timezone']['from']) {
          timezone.push(data['timezone']['from'])
        }
        if (data['timezone']['to']) {
          timezone.push(data['timezone']['to'])
        }
        Object.assign(filter, { timezone: timezone.join(',') })
      }
    }
    return filter
  },
  async changeProjectPublishstatus(id, status) {
    let url = config.serverUrl + 'updateproject-publishstatus'
    try {
      let res = await axios.post(url, {
        id: id,
        publish_status: status
      })
      return res
    } catch (error) {
      console.error(error)
      return false
    }
  },

  async getTagCustomer(data) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'tagcustomer'
    try {
      if (data.limit && data.offset >= 0) {
        url += `?limit=${data.limit}&offset=${data.offset}`
      }
      if (data.tagcustomer) {
        url += `&tagcustomer=${data.tagcustomer}`
      }
      if (data.isAll) {
        url += `&isAll=true`
      } else {
        url += `&isAll=false`
      }
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return { data: res.data.data, total: res.data.total }
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async getTagCustomerDropDown() {
    let url = config.serverUrl + 'tagcustomer'
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return { data: res.data.data, total: res.data.total }
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async addTagCustomer(body) {
    let url = config.serverUrl + 'tagcustomer'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.post(url, body)
      if (res.data.responsecode == 200 || res.data.responsecode == 300) {
        return { data: res.data }
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },

  async editTagCustomer(data) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let url = config.serverUrl + `tagcustomer/${data.id}`
      let res = await axios.put(url, {
        id: data.id,
        tagcustomer: data.tagcustomer
      })
      if (res.data.responsecode == 200 || res.data.responsecode == 300) {
        return { data: res.data }
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },

  async deleteTagCustomer(id) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let url = config.serverUrl + `tagcustomer/${id}`
      let res = await axios.delete(url, id)
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
      return false
    }
    // let url = config.serverUrl + `tagcustomer/${id}`
    // let res = await axios.delete(url, id)
    // return { data: res.data }
  },

  async getBadges(data) {
    let url = config.serverUrl + 'badges?'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      if (data.limit >= 0 && data.offset >= 0) {
        url += `limit=${data.limit}&offset=${data.offset}&`
      }
      if (data.nameAll) {
        url += `nameAll=${data.nameAll}&`
      }
      if (data.isAll) {
        url += `isAll=true`
      } else {
        url += `isAll=false`
      }
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return { data: res.data.data, total: res.data.total }
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async addBadges(body) {
    let url = config.serverUrl + 'badges'
    try {
      let res = await axios.post(url, body)
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async editBadges(id, data) {
    let url = config.serverUrl + `badges/${id}`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.put(url, {
        name: data.name,
        image_url: data.image_url,
        levels: data.levels
      })
      if (res.data.responsecode == 200) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async deleteBadges(id) {
    let url = config.serverUrl + `badges/${id}`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.delete(url)
      return res
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async depamemberlogs(memberid, params) {
    let url = config.serverUrl + `depamember/${memberid}/memberlogs`
    try {
      let res = await axios.get(url, { params })
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async downloadSlip(transactionId) {
    let url = config.serverUrl + 'paymentAdmin/' + transactionId + '/download'
    axios.defaults.headers.common = {
      AUTHORIZATION: `${store.getters.securityToken}`
    }
    try {
      let res = await axios.post(url, {}, { responseType: 'blob' })
      if (res.data) {
        return { data: res.data }
      } else {
        return { data: res.data }
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async depaProjectPayment(memberId, id) {
    let url = config.serverUrl + 'paymentAdmin/projectaplicant/' + id + '/' + memberId
    axios.defaults.headers.common = {
      AUTHORIZATION: `${store.getters.securityToken}`
    }
    try {
      let res = await axios.post(url, {})
      if (res.data) {
        return { data: res.data }
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async postChangePaymentStatus(id, item) {
    let url = config.serverUrl + 'payment/projectaplicant/' + id + '/updateStatus'
    let body = {
      status: item
    }
    try {
      let res = await axios.post(url, body)
      if (res.data.responsecode == 200) {
        // console.log(res.data)
        return res
      }
    } catch (error) {
      // console.error(error)
      return false
    }
  },
  async postPaymentSlipData(id) {
    let url = config.serverUrl + 'payment/' + id + '/slipData'
    let body = {}
    try {
      let res = await axios.post(url, body)
      if (res.data.responsecode == 200) {
        // console.log(res.data)
        return res
      }
    } catch (error) {
      // console.error(error)
      return false
    }
  },
  async memberInfoChangePayment(memberid, status) {
    let url = config.serverUrl + 'payment/register/updateStatus'
    let body = {
      status: status,
      memberid: memberid
    }
    try {
      let res = await axios.post(url, body)
      if (res.data.responsecode == 200) {
        // console.log(res.data)
        return res
      }
    } catch (error) {
      // console.error(error)
      return false
    }
  },
  async checkProductBadgeById(params) {
    let url = config.serverUrl + 'checkProductBadgeById'
    try {
      let res = await axios.get(url, { params })
      return res.data
    } catch (error) {
      console.log(error)
      return false
    }
  },
  async checkTagcustomer(params) {
    let url = config.serverUrl + 'checkTagcustomer'
    try {
      let res = await axios.get(url, { params })
      return res.data
    } catch (error) {
      console.log(error)
      return false
    }
  },

  async getdepaprojectbyid(params) {
    // { projectid: this.currentdata.projectid}
    let url = config.serverUrl + `getdepaprojectbyid`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.get(url, { params })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getdepaprojectformbyid(params) {
    // {customform: this.customform }
    let url = config.serverUrl + `getdepaprojectformbyid`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.get(url, { params })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getProductMember(memberid) {
    let url = config.serverUrl + 'getProduct'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    const data = { where: { memberid, form: 'owner' } }
    try {
      let res = await axios.post(url, data)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getProductTags() {
    let url = config.serverUrl + 'productTags'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.get(url)
      if (response.status == 200) {
        return response.data.data
      }
    } catch (error) {
      console.error(error)
      return 400
    }
  },
  async getProductTagId(params) {
    let url = config.serverUrl + 'producttag'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.get(url, { params })
      if (response.status == 200) {
        return response.data
      }
    } catch (error) {
      console.error(error)
      return 400
    }
  },
  async createProduct(params) {
    let url = config.serverUrl + 'createProduct'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.post(url, params)
      if (res.data.responsecode == 200) {
        return res.data.data
      } else if (res.data.responsecode == 204) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async editProduct(params, productid) {
    let url = config.serverUrl + `updateProduct/${productid}`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.patch(url, params)
      if (res.data.responsecode == 204) {
        return res.data.data
      } else if (res.data.responsecode == 204) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async depaconfirmapplication(params) {
    let url = config.serverUrl + 'depaconfirmapplication'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.post(url, params)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getDepaapplicantStatus(data) {
    let url = config.serverUrl + `depaapplicant/${data.applicantId}/status`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async postDepaapplicantConsider(data) {
    let url = config.serverUrl + `depaapplicant/${data.applicantId}/consider`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.post(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async postDepasendReport(data) {
    let url = config.serverUrl + `depasendreport`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.post(url, data)
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async deparesendnotifyformbystepid(data) {
    let url = config.serverUrl + `deparesendnotifyformbystepid`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.post(url, data)
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },

  async getDocument(params) {
    let url = config.serverUrl + 'depadocument'
    try {
      let res = await axios.get(url, { params })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async createDoc(data) {
    return new Promise(async resolve => {
      let url = config.serverUrl + 'depadocument'
      try {
        let res = await axios.post(url, data)

        resolve(res.data.responsecode)
      } catch (error) {
        console.error(error)
        resolve()
      }
    })
  },
  async deleteDoc(id) {
    let url = config.serverUrl + `depadocument/${id}`
    try {
      let res = await axios.delete(url)
      if (res.data.responsecode == 200 || res.data.responsecode == 400) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },
  async updateDoc(id, obj) {
    let url = config.serverUrl + `depadocument/${id}`
    try {
      let res = await axios.patch(url, obj)
      if (res.data.responsecode == 200) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },
  async createUnit(data) {
    return new Promise(async resolve => {
      let url = config.serverUrl + 'depaunitprice'
      try {
        let res = await axios.post(url, data)

        resolve(res.data.responsecode)
      } catch (error) {
        console.error(error)
        resolve()
      }
    })
  },
  async deleteUnit(id) {
    let url = config.serverUrl + `depaunitprice/${id}`
    try {
      let res = await axios.delete(url)
      if (res.data.responsecode == 200 || res.data.responsecode == 400) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },
  async updateUnit(id, obj) {
    let url = config.serverUrl + `depaunitprice/${id}`
    try {
      let res = await axios.patch(url, obj)
      if (res.data.responsecode == 200) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },
  async techhuntRegisterEmailAdmin(data) {
    let url = config.serverUrl + `techhunt-register-email-admin`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.post(url, {
        email: data.email,
        password: data.password,
        agencyid: data.agencyId
      })
      return res.data
    } catch (error) {
      console.error(error)
    }
  },
  async techhuntRegisterPhoneAdmin(data) {
    let url = config.serverUrl + `techhunt-register-phone-admin`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.post(url, {
        phone_number: data.phone_number,
        password: data.password,
        agencyid: data.agencyId
      })
      return res.data
    } catch (error) {
      console.error(error)
    }
  },
  async depamemberinfo(data) {
    let url = config.serverUrl + `depamemberinfo`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.put(url, data)
      if (res.data.responsecode == 200) {
        return res.data
      } else {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getdepaUnitId(params) {
    let url = config.serverUrl + 'depaunitprice'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.get(url, { params })
      if (response.status == 200) {
        return response.data
      }
    } catch (error) {
      console.error(error)
      return 400
    }
  },
  async updateProductQualification(productid, message) {
    let url = config.serverUrl + `updateProductQualification`
    let data = {
      productid,
      message
    }
    try {
      let res = await axios.post(url, data)
      if (res.data.responsecode == 200) {
        return res.data.responsecode
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getProductQualification(id) {
    let url = config.serverUrl + 'productQualification/' + id
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  //add more api from add members into project funtion
  async getProjectsByMember(params) {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'getProjectsByMember'
    try {
      let res = await axios.get(url, { header, params })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async checkMemberInfo(params) {
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'checkMemberInfo'
    try {
      let res = await axios.post(url, { header, params })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getdbdData(id) {
    let url = config.serverUrl + 'justric/profile/information?id_card=' + id
    let response = await axios.get(url).catch(e => {
      console.error(e)
    })
    if (response) {
      response = response.data
      return response
    } else {
      return {}
    }
  },
  async getShopData(id, memberid) {
    return new Promise(resolve => {
      axios
        .post(
          config.serverUrl + `getDefaultValueByTechproviderId/${id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${memberid || 'xxx'} ${store.state.userData.sessiontoken ||
                'xxx'}`
            }
          }
        )
        .then(response => {
          resolve(response)
        })
    })
  },

  depaapplyprojectform(data) {
    return new Promise(resolve => {
      axios
        .post(config.serverUrl + 'depaapplyprojectform', data, {
          headers: {
            AUTHORIZATION: store.getters.securityToken
          }
        })
        .then(async response => {
          resolve(response)
        })
    })
  },
  //qe code from add member
  async getPaymentStatus(params) {
    let url = config.serverUrl + 'payment/checkstatus'
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.get(url, { header, params: params })
      if (res.data) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async updateSlip(data) {
    let url = config.serverUrl + 'paymentAdmin/' + data.transaction_id + '/updateSlip'
    const dataSend = {
      slipfile: data.slipfile
    }
    let header = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.post(url, dataSend, { header })
      if (res.data.responsecode == 200) {
        return { data: res }
      } else {
        console.log(res)
        return { data: res }
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async sendLoginOTP(data) {
    let url = config.serverUrl + 'admin-login-email/'
    const sendData = {
      adminid: data
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: `${store.getters.securityToken}`
    }
    try {
      let res = await axios.post(url, sendData)
      if (res.data) {
        return { data: res.data }
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async verifyLoginOTP(_otp, _referral) {
    let url = config.serverUrl + 'admin-verify/'
    const sendData = {
      otp: _otp,
      referral: _referral
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: `${store.getters.securityToken}`
    }
    try {
      let res = await axios.post(url, sendData)
      if (res.data) {
        return { data: res.data }
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },

  // async updateProductAbout(data) {
  //   let url = config.serverUrl + 'updateProductAbout'
  //   axios.defaults.headers.common = {
  //     AUTHORIZATION: store.getters.securityToken
  //   }
  //   try {
  //     let response = await axios.post(url, data)
  //     if (response.data.responsecode == 200) {
  //       return true
  //     } else {
  //       return false
  //     }
  //   } catch (error) {
  //     return this.defaultError(error, null)
  //   }
  // },
  async getUserThaid(code) {
    let url = config.serverUrl + "useradminthaid";
    try {
      let res = await axios.get(url, { params: { code } });
      if (res) {
        return res.data;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  },
  async getPendingConsentRequests() {
    let url = config.serverUrl + `admin/consent-requests`
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getConsentRequestHistory() {
    let url = config.serverUrl + `admin/consent-requests/history`
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async decideConsentRequest(data) {
    let url = config.serverUrl + `admin/consent-requests/decide`
    try {
      let res = await axios.post(url, data)
      if (res.data.responsecode == 200) {
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  async getUserAzure(code) {
    let url = config.serverUrl + "useradminazure";
    try {
      let res = await axios.get(url, { params: { code } });
      if (res) {
        return res.data;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  },
}



// WEBPACK FOOTER //
// ./src/api/index.js